import { render } from "./UdyamVerificationAdd.vue?vue&type=template&id=397e4bb4&scoped=true"
import script from "./UdyamVerificationAdd.vue?vue&type=script&lang=js"
export * from "./UdyamVerificationAdd.vue?vue&type=script&lang=js"

import "./UdyamVerificationAdd.vue?vue&type=style&index=0&id=397e4bb4&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397e4bb4"]])

export default __exports__